<template>
  <div class="content-container flex-column">
    <div class="grid-x toolbar fixed">
      <div class="cell auto">
        <h4 class="no-margin toolbar-title">Verktøy</h4>
      </div>
    </div>

    <table class="large fixed clickable" style="width: 100%">
      <tbody>
        <tr v-for="item in sortedLinks" :key="item.likname" @click="onClick(item)">
          <td>{{item.name}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'VerktoyList',
  data () {
    return {
      links: [
        { name: 'Slå sammen Kunstner', linkname: 'VerktoyKunstnerMerge' }
      ]
    }
  },
  computed: {
    sortedLinks: function () {
      return this._.sortBy(this.links, ['name'])
    }
  },
  methods: {
    onClick: function (item) {
      this.$router.push({name: item.linkname})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Verktoy/VerktoyList.vue